import { CatalogueCard } from './catalogue-card';

export default CatalogueCard;
